import type { Transition } from "motion/react";

export const SEARCH_MIN_CHARS = 3;

export const SEARCH_MOTION_DURATION = 0.3;

export const SEARCH_MOTION_EASE = [0.4, 0, 0.2, 1] as const;

export const SEARCH_MOTION_TRANSITION: Transition = {
  duration: SEARCH_MOTION_DURATION,
  ease: SEARCH_MOTION_EASE,
};

// Overlay enter keyframe — replaces inline `style={{ animation: "overlay-enter ..." }}`
// + the orphaned @keyframes overlay-enter in globals.css.
export const SEARCH_OVERLAY_VARIANTS = {
  hidden: { opacity: 0, y: -10 },
  visible: { opacity: 1, y: 0 },
} as const;
